export default __webpack_public_path__ + "static/imgSSM5-0b5f083c8e854bfe5ba646199e79b605.png";